import styled from "@mui/material/styles/styled";

import { BaseFeedbackSnackbarContent } from "@app/analytics/components/reports/ReportFeedbackSnackbar";

export const ContentWrapper = styled(BaseFeedbackSnackbarContent)({
  width: "450px",
});
